import { Rectangle } from './math'
import jsPDF from 'jspdf'
import printJS from 'print-js'

export const PRINT_EVENT = 'PRINT_EVENT'
export const PRINT_AREA_ID = 'printArea'

export const A4_RATIO = 21 / 29.7

export const convertMmToPixels = (mm) => {
    return mm / 25.4 * 72
}

export const MARGIN_TOP = convertMmToPixels(20)
export const MARGIN_RIGHT = convertMmToPixels(10)
export const MARGIN_BOTTOM = convertMmToPixels(30)
export const MARGIN_LEFT = convertMmToPixels(10)

export class Margin {
    constructor(top = MARGIN_TOP, right = MARGIN_RIGHT, bottom = MARGIN_BOTTOM, left = MARGIN_LEFT)
    {
        this.top = top
        this.right = right
        this.bottom = bottom
        this.left = left
    }

    scale(factor)
    {
        if(factor < 0)
        {
            throw new Error('Cannot scale by negative factor')
        }

        return new Margin(
            this.top * factor,
            this.right * factor,
            this.bottom * factor,
            this.left * factor,
        )
    }

    apply(rect)
    {
        return new Rectangle(
            Math.max(rect.width - this.left - this.right, 0),
            Math.max(rect.height - this.top - this.bottom, 0),
            rect.position
        )
    }

    /**
     * Workaround specific to JSPDF. We have to apply twice the document scale factor!
     * Once to convert from px to pt and another to convert from pt to px (error from jspdf as we should not divide but multiply)
     */
    jspdfScale(doc)
    {
        if(doc.internal.scaleFactor <= 0)
        {
            throw new Error('JsPDF scale cannot use factor equal to or lower than 0')
        }

        return this.scale(1 / doc.internal.scaleFactor / doc.internal.scaleFactor)
    }
}

export const initPrintListener = () => {
    document.addEventListener(PRINT_EVENT, function (e) {
        const { title, orientation } = e.detail
        const canvas = document.getElementById(PRINT_AREA_ID).getElementsByTagName("canvas")[0]
        if(! canvas)
        {
            return
        }

        const doc = new jsPDF({
            orientation,
            unit: 'px',
        })

        const margin = (new Margin()).jspdfScale(doc)

        doc.setFontSize(11)
        doc.setFont('Courier')
        doc.text(title, margin.left, margin.top / 2, {baseline: 'top'})
        doc.addImage(
            canvas.toDataURL(),
            'JPEG',
            margin.left, margin.top,
            null, null, null,
            'SLOW'
        )

        printJS(doc.output('bloburl'))
    }, false)
}
